import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsTrinhDoVanHoa } from '../../services/danhmuc';

const TrinhDoVanHoaSelectBox = ({ value, disabled, onChange }: { value?: number, disabled?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsTrinhDoVanHoa(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn trình độ văn hóa--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default TrinhDoVanHoaSelectBox;
